import {
  type PasswordLoginMutationVariables,
  usePasswordLoginMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useLoginByPassword = () => {
  const [passwordLoginRequest, { data, loading, error }] =
    usePasswordLoginMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const loginByPassword = (variables: PasswordLoginMutationVariables) =>
    passwordLoginRequest({ variables });

  return {
    loginByPasswordProcessing: loading,
    loginByPasswordResult: data?.success,
    loginByPasswordError: error,
    loginByPassword,
  };
};
